import * as React from 'react';
import { useDeviceType } from '@cian/ui-kit';
import { ReferralBanner } from '../../components/ReferralBanner';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { useTracking } from './useTracking';

export const ReferralBannerContainer: React.FC = () => {
  const device = useDeviceType();
  const isDesktop = device === 'desktop';

  const { trackClickBannerBtn, trackShowBanner } = useTracking();

  const handleClick = React.useCallback(() => {
    trackClickBannerBtn();
    window.open('https://www.cian.ru/sdelka-referrer/?cian_source=referrerButtonCpdLanding_web', '_blank');
  }, [trackClickBannerBtn]);

  return (
    <ActionAfterViewObserver callback={trackShowBanner}>
      <ReferralBanner isDesktop={isDesktop} onClick={handleClick} />
    </ActionAfterViewObserver>
  );
};
